import { mapGetters } from 'vuex';
import moment from 'moment';

export const auth = {
	computed: {
		...mapGetters(['isAuthenticated', 'user', 'roles', 'token', 'siteText', 'mapColors', 'rememberMeToken']),
		localStorageToken() {
			return localStorage.getItem('auth_token');
		}
	},
	data() {
		return {
			roleNames: {
				pending: 'Pending',
				registered: 'Registered',
				admin: 'Admin',
				partialAdmin: 'PartialAdmin'
			}
		}
	},
	watch: {
		'$route'() {
			var storedToken = localStorage.getItem('auth_token');
			if (!storedToken || (storedToken !== this.token)) this.$store.commit('logout');
		}
	},
	methods: {
		getTokenHeader() {
			return {
				headers: { 'Authorization': 'Bearer ' + localStorage.getItem('auth_token') }
			};
		},
		getTokenHeaderPart() {
			return { 'Authorization': 'Bearer ' + localStorage.getItem('auth_token') };
		},
		isAuthorized(role) {
			return this.isAuthenticated && this.user.emailConfirmed && this.roles.includes(role);
		},
		logout(redirect = true) {
			localStorage.removeItem('auth_token');
			this.$store.commit('logout');
			if (redirect)
				this.$router.push('/').catch(err => { });
		},
		isApiUnauthorized(error) {
			return error.response && (error.response.status === 401 || error.response.status === 403);
		},
		rand() {
			return Math.random().toString(36).substr(2); // remove `0.`
		},
		generateRand() {
			return this.rand() + this.rand();
		},
		setRememberMe(userName) {
			let storedRememberDeviceString = localStorage.getItem('remember_device');
			let storedRememberDevice = [];
			if (storedRememberDeviceString !== undefined && storedRememberDeviceString !== null) {
				storedRememberDevice = JSON.parse(storedRememberDeviceString);
				let remembered = storedRememberDevice.filter(function (el) { return el.user !== userName; });
				storedRememberDevice = remembered;
			}

			let token = this.generateRand();

			storedRememberDevice.push({
				user: userName,
				timestamp: moment().format(),
				token: token
			});

			localStorage.setItem('remember_device', JSON.stringify(storedRememberDevice));

			this.$store.commit('storeRememberMeToken', {
				token: token
			});

			this.log(storedRememberDevice);
			this.log(token);

			return token;
		},
		getRememberMe(userName) {
			let storedRememberDeviceString = localStorage.getItem('remember_device');
			this.log(storedRememberDeviceString);
			if (storedRememberDeviceString === undefined || storedRememberDeviceString === null) {
				return null;
			}

			let storedRememberDevice = JSON.parse(storedRememberDeviceString);
			let remembered = storedRememberDevice.filter(function (el) { return el.user === userName; });
			if (remembered === null || remembered.length < 1) {
				return null;
			}

			return remembered[0].token;
		}
	}
};
